import { render, staticRenderFns } from "./ParticaArticleEdit.vue?vue&type=template&id=d18356b4&scoped=true&"
import script from "./ParticaArticleEdit.vue?vue&type=script&lang=ts&"
export * from "./ParticaArticleEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaArticleEdit.vue?vue&type=style&index=0&id=d18356b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18356b4",
  null
  
)

export default component.exports